import * as API from '@/endpoints'
import Axios from 'axios'

import axiosRetry from 'axios-retry';

axiosRetry(Axios, { retries: 0 });

export default {
    namespaced: true,
    state: {
        package: {},
        stories: []
    },
    getters: {
        getPackage(state){
            return state.package
        },
        getStories(state){
            return state.stories
        }
    },
    mutations: {
        setPackage(state, v){
            state.package = v
        },
        setStories(state, v){
            state.stories = v
        }
    },
    actions: {
        getPackage(context, payload){
            return new Promise((resolve, reject) => {
                let packageId = payload.default_package_id || context.rootState.brand.brand.default_package_id;
                // console.log(payload.default_package_id, context.rootState.brand.brand.default_package_id)
                // console.log("ID PACKAGE", packageId)
                Axios.get(API.endpoints.careplan + "/" + packageId, {
                    'axios-retry': {
                        retries: 3
                    }
                })
                .then(res => {
                    context.commit('setPackage', res.data)
                    resolve(res.data)
                },
                error => {
                    context.dispatch('exceptionHandling', {_err: error}, {root: 1})
                    reject(error)
                })
            })
        },
        getStories({commit, dispatch, state}){
            return new Promise((resolve, reject) => {
                Axios.get(API.endpoints.careplan + "/in/range/compiled", {
                    'axios-retry': {
                        retries: 3
                    },
                    params: {
                        careplan_ids: state.package.data.user_story.join()
                    }
                })
                .then(res => {
                    commit('setStories', res.data)
                    resolve(res.data)
                },
                error => {
                    dispatch('exceptionHandling', {_err: error}, {root: 1})
                    reject(error)
                })
            })
        }
    }
}